import { render, staticRenderFns } from "./ValueForMoneyForm.vue?vue&type=template&id=0a053adf&"
import script from "./ValueForMoneyForm.vue?vue&type=script&lang=js&"
export * from "./ValueForMoneyForm.vue?vue&type=script&lang=js&"
import style0 from "./ValueForMoneyForm.vue?vue&type=style&index=0&id=0a053adf&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports